import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HandHelping, Car, Heart, HardHat, Sparkles, ChefHat } from "lucide-react";

export default function Services() {
  const { t } = useTranslation();
  const SERVICES = [
    { icon: HandHelping, t: t("services.domestic_t"),     d: t("services.domestic_d") },
    { icon: Heart,       t: t("services.caregiver_t"),    d: t("services.caregiver_d") },
    { icon: Car,         t: t("services.driver_t"),       d: t("services.driver_d") },
    { icon: HardHat,     t: t("services.industrial_t"),   d: t("services.industrial_d") },
    { icon: ChefHat,     t: t("services.hospitality_t"),  d: t("services.hospitality_d") },
    { icon: Sparkles,    t: t("services.custom_t"),       d: t("services.custom_d") },
  ];
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="overline mb-4">{t("services.overline", "Services")}</div>
      <h1 className="font-serif text-5xl md:text-6xl text-zinc-950 tracking-tight max-w-4xl">{t("services.title")}</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
        {SERVICES.map((s) => (
          <div key={s.t} className="border border-zinc-200 rounded-3xl p-8 card-lift bg-white" data-testid={`service-${s.t}`}>
            <s.icon className="text-[#b8860b] mb-4" size={28} />
            <div className="font-serif text-2xl text-zinc-950 mb-2">{s.t}</div>
            <p className="text-zinc-900 leading-relaxed">{s.d}</p>
          </div>
        ))}
      </div>

      <div className="mt-16 bg-zinc-950 text-white rounded-3xl p-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <div className="overline text-[#d4a017] mb-2">{t("home.cta_overline", "Ready to begin?")}</div>
          <div className="font-serif text-3xl">{t("home.cta_title")}</div>
        </div>
        <Link to="/catalog" className="btn-gold">{t("action.view_profile", "View Catalog")}</Link>
      </div>
    </div>
  );
}
